"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    type: Number,
    item: Object
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    }
  },
  data: function data() {
    return {
      notImg: require("@/assets/404_images/notimg.png")
    };
  },
  created: function created() {},
  methods: {
    handleImageError: function handleImageError(e) {
      e.target.onerror = null;
      e.target.src = this.notImg;
    },
    lookDetails: function lookDetails(e) {
      console.log(e, 'e');
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["course_click", "CLK", {
          //以下为事件属性
          course_name: e.courseName,
          // 课程名称
          course_id: e.newId ? e.newId : e.id,
          //课程id
          college_name: e.fkCourseEmceeSchool,
          // 所属学校
          major_name: e.fkCourseMajor // 所属专业
        }]
      });
      if (this.type == 10) {
        this.$router.push({
          path: "/courseDetail",
          query: {
            courseId: e.courseId,
            id: e.id
          }
        });
      } else {
        window.open(e.courseLink);
      }
    }
  }
};